import React, { useState, useContext } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
} from "../../../utils";
import { downloadMapperListReport } from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";

function MapperList(props) {
  const formName = manageReportsFormNames.MAPPER_LIST_REPORT;
  const fields = formFields[formName];
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });
  const initialValues = { profileType: "All", profileTypeId: null };
  const profileTypes = [
    { label: "All", value: null },
    { label: "Input", value: 1 },
    { label: "Output", value: 2 },
    { label: "Passthrough", value: 3 },
  ];

  const exportReportFile = (payload) => {
    downloadMapperListReport(payload)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `MapperListReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };
  const onSubmit = (values) => {
    exportReportFile(values[fields.profileTypeId]);
  };

  return (
    <ManageReportLayout rptName="Mapper List Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const onStatusChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planStatus, fields.planStatusId],
                  }),
                  [fields.profileTypeId]:
                    value || value === 0 ? parseInt(value) : null,
                  [fields.profileType]:
                    value || value === 0 ? profileTypes[value].label : "All",
                });
              };
              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex ">
                    <div className="mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label={`Profile type`}
                        name={fields.profileType}
                        value={values[fields.profileType]}
                        placeholder="Select One"
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.profileType])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Profile type"
                            options={profileTypes}
                            onSelect={(value) => onStatusChange(value)}
                            selectedValue={values[fields.planStatus]}
                          />
                        }
                        component={FieldDropSide}
                      />
                    </div>
                    <div>
                      {" "}
                      <Button
                        className="mt-12 sort-button"
                        variant="secondary"
                        style={{ marginLeft: "8px", marginTop: "30px" }}
                        type="submit"
                      >
                        Request Report
                      </Button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </ManageReportLayout>
  );
}

export default MapperList;
